module.exports = __webpack_public_path__ + "public/img/many.6e4e4fca.gif";